const EyeIconCrossedOutFilled = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99967 5.41673C12.2997 5.41673 14.1663 7.2834 14.1663 9.5834C14.1663 10.0084 14.083 10.4167 13.9663 10.8001L16.5163 13.3501C17.6747 12.3251 18.5913 11.0417 19.1663 9.57506C17.7247 5.92506 14.1663 3.3334 9.99967 3.3334C8.94134 3.3334 7.92467 3.50007 6.96634 3.8084L8.77467 5.61673C9.16634 5.50006 9.57467 5.41673 9.99967 5.41673ZM2.25801 2.6334C1.93301 2.9584 1.93301 3.4834 2.25801 3.8084L3.89967 5.45006C2.54967 6.52506 1.47467 7.94173 0.833008 9.5834C2.27467 13.2417 5.83301 15.8334 9.99967 15.8334C11.2663 15.8334 12.4747 15.5834 13.5913 15.1501L15.858 17.4167C16.183 17.7417 16.708 17.7417 17.033 17.4167C17.358 17.0917 17.358 16.5667 17.033 16.2417L3.44134 2.6334C3.11634 2.3084 2.58301 2.3084 2.25801 2.6334ZM9.99967 13.7501C7.69967 13.7501 5.83301 11.8834 5.83301 9.5834C5.83301 8.94173 5.98301 8.3334 6.24134 7.80006L7.54967 9.1084C7.52467 9.2584 7.49967 9.41673 7.49967 9.5834C7.49967 10.9667 8.61634 12.0834 9.99967 12.0834C10.1663 12.0834 10.3163 12.0584 10.4747 12.0251L11.783 13.3334C11.2413 13.6001 10.6413 13.7501 9.99967 13.7501ZM12.4747 9.3084C12.3497 8.14173 11.433 7.2334 10.2747 7.1084L12.4747 9.3084Z"
      fill="#161015"
    />
  </svg>
)

export default EyeIconCrossedOutFilled
